var _defs, _path, _path2, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5333f;}.cls-2{fill:#011e41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.07,100.71a186.28,186.28,0,0,0-230.14,0L125,88.13a202.29,202.29,0,0,1,249.92,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.13,154.25a32,32,0,1,1,32-32A32,32,0,0,1,250.13,154.25Zm0-48a16,16,0,1,0,16,16A16,16,0,0,0,250.13,106.25Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "268.1 447.08 268.1 165.62 282.75 165.62 303.47 226.07 345.29 200.84 369.21 200.84 369.21 216.84 349.74 216.84 294.76 250.01 284.1 218.91 284.1 447.08 268.1 447.08"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "232.46 447.08 216.46 447.08 216.46 219.79 206.31 250 150.84 216.84 131.35 216.84 131.35 200.84 155.26 200.84 197.47 226.07 217.77 165.62 232.46 165.62 232.46 447.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralidad);
export default __webpack_public_path__ + "static/media/neutralidad.c6e4b7e14348a3fd6031962a80d0fd1c.svg";
export { ForwardRef as ReactComponent };